import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle, FaTimesCircle } from 'react-icons/fa';
import axiosInstance from '../api/axiosInstance';

const PostingLimitChecker = ({ onCanPost }) => {
  const [checkResult, setCheckResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkPostingLimit();
  }, []);

  const checkPostingLimit = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/warnings/check-post-limit');
      setCheckResult(response.data);
      
      // Callback für Eltern-Komponente
      if (onCanPost) {
        onCanPost(response.data.canPost);
      }
    } catch (error) {
      console.error('Fehler beim Prüfen des Post-Limits:', error);
      setCheckResult({
        canPost: false,
        reason: 'Fehler beim Prüfen der Berechtigung',
        type: 'error'
      });
      
      if (onCanPost) {
        onCanPost(false);
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-gray-600">
        <span className="loading loading-spinner loading-sm"></span>
        Prüfe Berechtigung...
      </div>
    );
  }

  if (!checkResult) {
    return null;
  }

  if (checkResult.canPost) {
    return null; // Keine Anzeige wenn posten erlaubt ist
  }

  // Posting nicht erlaubt - zeige Warnung
  return (
    <div className="mb-4">
      {checkResult.type === 'banned' ? (
        <div className="alert alert-error">
          <FaTimesCircle />
          <div>
            <h4 className="font-bold">Posting nicht möglich</h4>
            <p>{checkResult.reason}</p>
          </div>
        </div>
      ) : checkResult.type === 'yellow_card_limit' ? (
        <div className="alert alert-warning">
          <FaExclamationTriangle />
          <div>
            <h4 className="font-bold">Tageslimit erreicht</h4>
            <p>{checkResult.reason}</p>
            <div className="mt-2 text-sm">
              <strong>Posts heute:</strong> {checkResult.postsToday} / {checkResult.limit}
            </div>
          </div>
        </div>
      ) : (
        <div className="alert alert-error">
          <FaTimesCircle />
          <div>
            <h4 className="font-bold">Posting nicht möglich</h4>
            <p>{checkResult.reason}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostingLimitChecker;
